(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["loyalty-future-rewards"]) return;
  try {
    

  function updateFutureTeirPoints({ next_tier }) {
    const progressCtaTarget = document.querySelectorAll('.loyalty-user-future-rewards-cta');
    if( !next_tier?.to_spend_or_earn || !progressCtaTarget || next_tier.name === "Private" ) return;
    progressCtaTarget.forEach(el => {
      el.innerHTML = `${next_tier?.to_spend_or_earn} points away`;
    });

    return
  }

  function updateFutureTeirCta({ next_tier }) {
    const progressCtaTarget = document.getElementById('loyalty-user-future-rewards-next-tier');
    const progressCtaContainerTarget = document.querySelector('.loyalty-user-future-rewards-next-tier__container');
    if( !next_tier?.to_spend_or_earn || !progressCtaTarget || next_tier.name === "Private" ) return;
    progressCtaTarget.innerHTML = `Earn another <strong>${next_tier?.to_spend_or_earn} points</strong> to unlock ${next_tier?.name}.`;
    progressCtaContainerTarget.style.display = 'block';
    progressCtaTarget.style.display = 'block';
    return
  }

  function updateFutureProgressBar({ next_tier }) {
    const progressBarTarget = document.getElementById('loyalty-user-future-rewards__progress-bar');
    const progressCtaContainerTarget = document.querySelector('.loyalty-user-future-rewards-next-tier__container');
    if( !next_tier?.to_spend_or_earn || !progressBarTarget || next_tier.name === "Private" ) return;
    const currentPoints = next_tier?.threshold - next_tier?.to_spend_or_earn;

    const progressPercentage = (currentPoints / next_tier?.threshold) * 100;

    progressBarTarget.style.width = `${progressPercentage}%`;
    progressCtaContainerTarget.style.display = 'block';
    progressBarTarget.style.display = 'block';
    return
  }
  

  document.addEventListener('rivo-js-loaded', function() {
    if (!ShopifyAnalytics?.meta?.page?.customerId) return
    RivoJS.getCustomerVipTier().then(function(resp) {
      updateFutureTeirPoints(resp);
      updateFutureTeirCta(resp);
      updateFutureProgressBar(resp);
    }).catch(function(error) {
        console.error('Error occurred while getting customer VIP tier: ', error);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loyalty-user-points"]) return;
  try {
    

  function updateNextTeirCta({ next_tier }) {
    const progressCtaTarget = document.getElementById('account-loyalty__progress-cta');

    if( !next_tier?.to_spend_or_earn || !progressCtaTarget || next_tier.name === "Private" ) return;
    progressCtaTarget.innerHTML = `Earn another <strong>${next_tier?.to_spend_or_earn} points</strong> to unlock ${next_tier?.name}.`;
    progressCtaTarget.style.display = 'block';
    return
  }

  function updateProgressBar({ next_tier }) {
    let progressBarTarget = document.getElementById('account-loyalty__progress-bar');
    if( !next_tier?.to_spend_or_earn || !progressBarTarget || next_tier.name === "Private" ) return;
    const currentPoints = next_tier?.threshold - next_tier?.to_spend_or_earn;
    const progressPercentage = (currentPoints / next_tier?.threshold) * 100;
    progressBarTarget.style.width = `${progressPercentage}%`;
    progressBarTarget.style.display = 'block';
    return
  }
  
  function updatePointsExpiry({ points_expiry }) {
    const pointsExpiryTarget = document.getElementById('account-loyalty__point-expiry');
    if( !points_expiry && !pointsExpiryTarget ) return;
    // Assuming points_expiry is a string like "January 04, 2025"
    let expiryDate = new Date(points_expiry);
    let options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    let formattedExpiryDate = expiryDate.toLocaleDateString('en-AU', options);
    
    pointsExpiryTarget.innerHTML = `Expiry date: ${formattedExpiryDate}`;
    pointsExpiryTarget.style.display = 'block';
    return
  }
  
  function updateRewardsTable({ points_logs }) {
    const tableBodyTarget = document.getElementById('user-points__table-body');
    if( !points_logs || !tableBodyTarget || tableBodyTarget.classList.contains('loaded') ) return;

    points_logs.forEach(log => {
      // Create a new table row and its cells
      let row = document.createElement('tr');
      let cellNote = document.createElement('td');
      let cellDiff = document.createElement('td');
      let cellDate = document.createElement('td');

      // Add the external note, points diff, and applied at data to the cells
      cellNote.textContent = log.external_note;
      cellDiff.textContent = log.points_diff;
      // Format the date as dd/mm/yy
      let date = new Date(log.applied_at);
      let options = { year: '2-digit', month: '2-digit', day: '2-digit' };
      cellDate.textContent = date.toLocaleDateString('en-AU', options);

      // Append the cells to the row
      row.appendChild(cellNote);
      row.appendChild(cellDiff);
      row.appendChild(cellDate);

      // Append the row to the table body
      tableBodyTarget.appendChild(row);
    });
    tableBodyTarget.classList.add('loaded');
    return
  }
  document.addEventListener('rivo-js-loaded', function() {
    if (!ShopifyAnalytics?.meta?.page?.customerId) return
    RivoJS.getCustomerVipTier().then(function(resp) {
      updateNextTeirCta(resp);
      updateProgressBar(resp);
    }).catch(function(error) {
        console.error('Error occurred while getting customer VIP tier: ', error);
    });
    RivoJS.getCustomerDetails().then(function(resp) {
      updatePointsExpiry(resp);
    }).catch(function(error) {
        console.error('Error occurred while getting customer details: ', error);
    });
    RivoJS.getCustomerPointsLogs().then(function(resp) {
      updateRewardsTable(resp);
    }).catch(function(error) {
        console.error('Error occurred while getting customer points: ', error);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-recommendations-tabbed"] && !Shopify.designMode) return;
  try {
    
    var handleTabs = function() {
      var tabHeadings = document.querySelectorAll('.product-recommendations__tab-heading');
      var tabContents = document.querySelectorAll('.product-recommendations__tab-content');
      // add click handler to each tabHeading, add active class to it and remove from all others, then add active class to corresponding tabContent and remove from all others
      tabHeadings.forEach(function (tabHeading) {
        tabHeading.addEventListener('click', function (event) {
          event.preventDefault();
          var tabHeadingId = event.currentTarget.dataset.tabIndex;
          var tabContent = tabContents[tabHeadingId];
          tabHeadings.forEach(function (tabHeading) {
            tabHeading.classList.remove('active');
          });
          tabContents.forEach(function (tabContent) {
            tabContent.classList.remove('active');
          });
          tabHeading.classList.add('active');
          tabContent.classList.add('active');
        });
      });
    }
    
    // fetch when section reloads in editor
    document.addEventListener('shopify:section:load', function (event) {
      if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
        handleTabs();
      }
    });
    
    // Init tabs on load
    handleTabs();
  
  } catch(e) { console.error(e); }
})();
})();
